import { PublicClientApplication } from '@azure/msal-browser';

// Do not reuse the portal's administrative MSAL instance or account cache.
// Completing a learner sign-in must not sign that person into /admin.
export async function createTrainingMicrosoft(auth) {
  const client = new PublicClientApplication({ auth: {
    clientId: auth.clientId,
    authority: `https://login.microsoftonline.com/${auth.tenantId}`,
    redirectUri: `${window.location.origin}/auth-popup.html`
  }, cache: { cacheLocation: 'memoryStorage' } });
  await client.initialize();
  return client;
}
